/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WidgetBookEventPayload } from '../models/WidgetBookEventPayload';
import type { WidgetBookEventResponse } from '../models/WidgetBookEventResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WidgetBookingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Book event as authenticated widget client
     * Book a generated event as an authenticated widget client (bearer JWT required).
     * @param therapistUuid
     * @param requestBody
     * @returns WidgetBookEventResponse
     * @throws ApiError
     */
    public widgetBookEventAsClient(
        therapistUuid: string,
        requestBody: WidgetBookEventPayload,
    ): CancelablePromise<WidgetBookEventResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events/{therapistUUID}/book-as-client',
            path: {
                'therapistUUID': therapistUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public widgetBookingControllerOptionsBookAsClient(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'OPTIONS',
            url: '/events/{therapistUUID}/book-as-client',
        });
    }
}
